export interface INotificationMessage {
  type: MessageType;
  entity: Entity;
  sid: string;
  payload: any;
  club: string;
  additionalData?: any;
}

export enum MessageType {
  New = 1,
  Update = 2,
  Delete = 3,
  DeleteMany = 4,
}

export enum Entity {
  Video = 1,
  Playlist = 2,
  Event = 3,
  ScheduledRecording = 4,
  HlsRecording = 5,
  Recorder = 6,
  EventPanel = 7,
  EventAction = 8,
  Canvas = 9,
  TaggingSession = 10,
  Player = 11,
  Match = 12,
  MatchPeriod = 13,
  Club = 14,
  ClubAlbum = 15,
  Producer = 16,
  RecorderStream = 17,
  /** Opdracht van het platform aan een studio; niets voor het webapp. */
  RecorderCommand = 19,
}
